<template>
  <aside class="menu" v-if="classrooms && classrooms.length">
    <div class="field">
      <div class="control">
        <input
          v-model="classrooms_filter"
          class="input"
          type="text"
          :placeholder="$t('classroom filter')"
        />
      </div>
    </div>
    <ul class="menu-list">
      <li
        v-for="(classroom, cidx) in filtered_classrooms"
        :key="cidx"
        @click="select_classroom(classroom)"
      >
        <a
          :class="{
            'is-active':
              selected_classroom && selected_classroom.uuid == classroom.uuid,
          }"
        >
          <!-- <pre>{{ classroom }}</pre> -->
          <div class="title is-6">{{ classroom.course.name }}</div>
          <div class="subtitle is-6">
            {{ classroom.professor.first_name }}
            {{ classroom.professor.first_surname }}
            <small>[{{ classroom.student_count }}]</small>
          </div>
        </a>
      </li>
    </ul>
    <classroom-modal
      ref="classroom_modal"
      @classroom_created="get_classrooms(current_period)"
      @classroom_updated="
        get_classrooms(current_period);
        $emit('classroom_updated');
      "
    />
  </aside>
  <!-- <section class="section">
    <div class="container">
      <div class="field">
        <div class="control">
          <input
            v-model="classrooms_filter"
            class="input"
            type="text"
            :placeholder="$t('classroom filter')"
          />
        </div>
      </div>
      <div v-if="classrooms.length === 0" class="notification is-warning">
        {{ $t("no classrooms found") }}
      </div>
      <div v-else>
        <div
          class="box"
          v-for="(classroom, cidx) in filtered_classrooms"
          :key="cidx"
        >
          <div class="button is-pulled-right" @click="get_classroom(classroom)">
            <span class="icon">
              <i class="fa fa-list"></i>
            </span>
            <span>{{ $t("load details") }}</span>
          </div>
          <div class="title is-5">
            <span class="icon">
              <i class="fa fa-book"></i>
            </span>
            {{ classroom.course?.name }}
          </div>
          <div class="subtitle is-5">
            <span class="icon">
              <i class="fa fa-user"></i>
            </span>
            {{
              classroom.professor
                ? `${classroom.professor.first_name} ${classroom.professor.first_surname}`
                : ""
            }}
          </div>
          <classroom-detail ref="classroom_detail" />
        </div>
      </div>
    </div>
    <classroom-modal
      ref="classroom_modal"
      @success="get_classrooms(current_period)"
    />
  </section> -->
</template>

<script>
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  get,
  error_message,
  format_currency,
  input_alert,
} from "@/utils";
import ClassroomModal from "./classroom_modal/Index.vue";
// import ClassroomDetail from "./ClassroomDetail.vue";

export default {
  name: "ClassroomList",
  components: { ClassroomModal /* ClassroomDetail */ },
  data() {
    return {
      classrooms_filter: "",
      classrooms: [],
      current_period: {},
      selected_classroom: null,
    };
  },
  computed: {
    filtered_classrooms() {
      let v = this;
      return v.classrooms.filter((c) => {
        return (
          c.course.name
            .toLowerCase()
            .includes(v.classrooms_filter.toLowerCase()) ||
          c.professor.first_name
            .toLowerCase()
            .includes(v.classrooms_filter.toLowerCase()) ||
          c.professor.first_surname
            .toLowerCase()
            .includes(v.classrooms_filter.toLowerCase())
        );
      });
    },
  },
  methods: {
    get_classrooms(period) {
      let v = this;
      v.current_period = period;
      // get("/student-professor-portal/my-classroom/all", {
      get("/professor-portal/classroom/all", {
        period_uuid: period.uuid,
      })
        .then((response) => {
          v.classrooms = response;
          v.$emit("classrooms_loaded", response);
        })
        .catch((error) => {
          error_message(error);
        });
    },
    // new_classroom(period) {
    //   let v = this;
    //   v.$refs.classroom_modal.create(period);
    // },
    // get_classroom(classroom) {
    //   let v = this;
    //   get("/student/classroom", { uuid: classroom.uuid })
    //     .then((response) => {
    //       let idx = v.classrooms.findIndex((c) => c.uuid === classroom.uuid);
    //       v.$refs.classroom_detail[idx].set_classroom(response);
    //     })
    //     .catch((error) => {
    //       error_message(error);
    //     });
    // },
    select_classroom(classroom) {
      let v = this;
      v.selected_classroom = classroom;
      v.$emit("classroom_selected", classroom);
    },
    edit_classroom(classroom) {
      let v = this;
      v.$refs.classroom_modal.edit(classroom);
    },
  },
};
</script>

<style scoped>
.section {
  padding-top: 2rem;
}
.box {
  margin-bottom: 1rem;
}
</style>
